import { render, staticRenderFns } from "./organization-credit-plans-card.vue?vue&type=template&id=2202584d"
import script from "./organization-credit-plans-card.vue?vue&type=script&lang=js"
export * from "./organization-credit-plans-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports